// extracted by mini-css-extract-plugin
export default {"threshold-info":"ThresholdInfo_threshold-info__vgY6a","threshold-info__text":"ThresholdInfo_threshold-info__text__UT4CB"};